import React from "react";
import WhitePdfButton from "../../../WhitePdfButton/WhitePdfButton";
import tlushIcon from "../../../../assets/images/tlush-icon.png";
import SalaryData from "../../../../entities/SalaryData";
import { convertMonth } from "../../../../utils/helpers/monthConverter";
import { numberWithCommas } from "../../../../utils/helpers/numberConverter";
import { useTranslation } from "react-i18next";
import "./RenderPensionDetails.scss";

function RenderPensionDetails(props: { salary: SalaryData }) {
  const { i18n } = useTranslation("common");
  return (
    <div className="rest-pension-table-item" role="row">
      <img src={tlushIcon} alt="" className="line-img" />
      <span className="pension-table-item-label" role="cell">
        {`${convertMonth(
          parseInt(props.salary.salaryDate.split("-")[1]),
          i18n.language
        )}`}{" "}
        {`${props.salary.salaryDate.split("-")[0]}`}
      </span>
      <span className="pension-table-item-label" role="cell">{`${numberWithCommas(
        Math.floor(props.salary.salaryNeto)
      )} ₪`}</span>
      <div className="desktop">
        <WhitePdfButton salaryDate={props.salary.salaryDate} />
      </div>
      <div className="mobile">
        <WhitePdfButton salaryDate={props.salary.salaryDate} />
      </div>
    </div>
  );
}

export default RenderPensionDetails;
